module.exports = __webpack_public_path__ + "img/62fd75f8f707f565ffb1ec3ed724bc07.png";